import React from 'react';
import { useTranslation } from 'react-i18next';
import Table from '../../tables/Table';

import useCustomTable from '../../tables/useCustomTable';
import * as Format from "../../Format";
import Pagination from "../../tables/Pagination";

const ConsentByDayTable = ({data}) => {
  const { t } = useTranslation();
  const {
    tableProps,
    paginationProps,
    tableSearchProps
  } = useCustomTable({
    sortable: true,
    paginate: true,
    sortBy: {date: 'asc'}
  });

  const columns = [{
    Header: 'Date',
    accessor: 'date',
    id: 'date',
    format: 'date'
  },{
    Header: t("cmp.analytics.metrics.devices"),
    accessor: 'devices',
  },{
    Header: t("cmp.analytics.metrics.devicesWithCmpPresented"),
    accessor: 'devicesWithCmpPresented',
  },{
    Header: t("cmp.analytics.metrics.presentationRate"),
    Cell: ({row}) => <Format.Percent value={row.original.presentationRate*100}/>,
    accessor: 'presentationRate',
  },{
    Header: t("cmp.analytics.metrics.consentedDevices"),
    accessor: 'consentedDevices',
  },{
    Header: t("cmp.analytics.metrics.consentRate"),
    Cell: ({row}) => <Format.Percent value={row.original.consentRate*100}/>,
    accessor: 'consentRate',
  },{
    Header: t("cmp.analytics.metrics.dailyCmpPresented"),
    accessor: 'dailyCmpPresented',
  },{
    Header: t("cmp.analytics.metrics.dailyConsents"),
    accessor: 'dailyConsents',
  },{
    Header: t("cmp.analytics.metrics.dailyConsentRate"),
    Cell: ({row}) => <Format.Percent value={row.original.dailyConsentRate*100}/>,
    accessor: 'dailyConsentRate',
  },{
    Header: t("cmp.analytics.metrics.dailyAverageDisplayRank"),
    accessor: 'dailyAverageDisplayRank',
  }
  ];
  return (<>
    <Table noPadding data={data} columns={columns} {...tableProps} />
    <Pagination {...paginationProps}/>
  </>)
}

export default ConsentByDayTable
